import React from "react";
import { DECISION_GUIDE, WHATSAPP_URL } from "@/lib/site";
import { CircleDot, MessageCircle } from "lucide-react";

export default function DecisionGuide() {
    return (
        <section
            id="decision-guide"
            data-testid="decision-guide-section"
            className="py-20 md:py-24 bg-[color:var(--paper-tint)]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <div className="font-mono-label text-[color:var(--maroon)]">
                        Decision Guide
                    </div>
                    <h2
                        className="mt-3 font-serif text-4xl sm:text-5xl text-[color:var(--navy)] tracking-tight leading-tight"
                        style={{ fontWeight: 500 }}
                    >
                        Not Sure Which Workshop to Join?
                    </h2>
                    <div className="hr-gold mt-5" />
                    <p className="mt-5 text-slate-600 leading-relaxed">
                        Use this quick guide to pick the right starting point for your current
                        research stage.
                    </p>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {DECISION_GUIDE.map((d, i) => (
                        <div
                            key={i}
                            data-testid={`decision-card-${i + 1}`}
                            className={`rounded-2xl bg-white border border-[color:var(--line)] p-6 flex items-start gap-4 hover:border-[color:var(--maroon)] transition-colors ${
                                i === DECISION_GUIDE.length - 1 ? "md:col-span-2 bg-[color:var(--beige-soft)]" : ""
                            }`}
                        >
                            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[color:var(--maroon)]/8 text-[color:var(--maroon)]">
                                <CircleDot className="h-4 w-4" />
                            </span>
                            <div className="flex-1">
                                <div className="font-mono-label text-slate-500 mb-1">
                                    If
                                </div>
                                <p className="font-serif text-lg text-[color:var(--navy)] leading-snug">
                                    {d.condition}
                                </p>
                                <div className="mt-3 inline-flex items-center gap-2 rounded-full bg-[color:var(--gold)]/12 border border-[color:var(--gold)]/25 px-3 py-1.5">
                                    <span className="font-mono-label text-[color:var(--gold)]">Then</span>
                                    <span className="text-sm text-[color:var(--navy)] font-semibold">
                                        {d.pick}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-10 rounded-2xl bg-white border border-[color:var(--line)] p-6 sm:p-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <div className="font-mono-label text-[color:var(--maroon)]">
                            Still unsure?
                        </div>
                        <p className="mt-1 text-slate-700">
                            WhatsApp us and we will help you choose the right workshop for your stage.
                        </p>
                    </div>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="decision-whatsapp-btn"
                        className="btn-navy inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm shrink-0"
                    >
                        <MessageCircle className="h-4 w-4" />
                        WhatsApp us
                    </a>
                </div>
            </div>
        </section>
    );
}
